__webpack_require__.p = "/digitalphotobooth/template1/";